<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
//import VueCookies from 'vue-cookies';
export default {
  name: 'App',
  data() {
    return {

    }
  },
  mounted() {
    // 禁用鼠标右键和F12
    // document.addEventListener('contextmenu', this.disableRightClick);
    // document.addEventListener('keydown', this.disableF12);
  },
  destroyed() {

  },
  methods: {
    // 禁用鼠标右键和F12
    disableRightClick(event) {
      event.preventDefault();
    },
    disableF12(event) {
      if (event.keyCode === 123) {
        event.preventDefault();
      }
    }
  }
}
</script>

<style>
/* reset.css */
* {
  box-sizing: content-box;
}

html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: transparent;
  box-sizing: border-box;
}

@media (max-width: 320px) {
  html {
    font-size: 4px;
  }
}

@media (min-width: 320px) and (max-width: 400px) {
  html {
    font-size: 5px;
  }
}

@media (min-width: 400px) and (max-width: 520px) {
  html {
    font-size: 6px;
  }
}

@media (min-width: 521px) and (max-width: 768px) {
  html {
    font-size: 8px;
  }
}

@media (min-width: 768px) and (max-width: 992px) {
  html {
    font-size: 10px;
  }
}

@media (min-width: 992px) and (max-width: 1200px) {
  html {
    font-size: 13px;
  }
}

@media (min-width: 1200px) {
  html {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue